
import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import TileWMS from 'ol/source/TileWMS';
import LayerSwitcher from 'ol-layerswitcher';
import "ol-layerswitcher/src/ol-layerswitcher.css";
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {Circle as CircleStyle,Fill,   RegularShape, Stroke, Style, Text} from 'ol/style';
 
import { Timeline,DataSet } from "vis-timeline/standalone";
import Point from 'ol/geom/Point';
import Layer from 'ol/layer/Layer';
import {fromLonLat} from 'ol/proj.js';
import {getVectorContext} from 'ol/render.js';

import Feature from 'ol/Feature';


import LayerGroup from 'ol/layer/Group';
import Collection from 'ol/Collection';
import { Circle } from 'leaflet';



window.test_var=1

////Strelice _radar 
const source_arr = new VectorSource();

 
//const colorsrange=['#66a06f', '#69a58d', '#75a69e', '#89a4a4', '#a29e9f', '#bd948d', '#d68471', '#ed6c48', '#ff4700']

window.tockice= new VectorLayer({
  title:'Simulacija kretanja čestica',
  source: source_arr,
  /*style: function (feature) {

     
      let head1 = new CircleStyle({
       radius: 2,
       fill: new Fill({color: feature.get('color')}),

    });
    console.log('style')
 
 
    let styles = [ new Style({image: head1})];
 
    return  styles;
  },*/
 // style: new Style( {image: new CircleStyle({radius: 2,fill: new Fill({color: 'red'}),})}),
 style: function (feature) {
    return feature.getStyle()
 },
  visible:false,
})
//strelice.visibilitychanged(function(){console.log('something cgabged')}) 
//strelice.events.register('change', obj, function(obj){console.log(obj)});


const puri_control=document.getElementById('puri_control')


//tockice.on('visibilitychanged',function(){console.log('aaaaaa')})

window.tockice.on('change:visible', function (e) {

 
  if(!e.oldValue){
    puri_control.style.display='block'

  }
  else{
    puri_control.style.display='none'

  }
})
//strelice radar


 
//var radar_data=['radar2023-09-13-2000.ruv.json', 'radar2023-09-25-1100.ruv.json']
 

const datum_slider_radar=document.getElementById('cestice_slider')//.onchange(function(event){  console.log(event)})
datum_slider_radar.setAttribute('min',0)

datum_slider_radar.setAttribute('max',702)//radar_data.length)
 
const style_list=[new Style({image:new CircleStyle({radius:2, fill: new Fill({color: 'purple'}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(0,0,170)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb( 0,0,255)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(0,85,255)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(0,170,255)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(0,255,255)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(85,255,170)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(170,255,85)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(255,255,0)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(255,170,0)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(255,85,0)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(255,0,0)"}),})}),
new Style({image:new CircleStyle({radius:2, fill: new Fill({color: "rgb(170,0,0)"}),})})
]


var legendDiv = document.createElement('div');
legendDiv.id = 'legend_cestice';
puri_control.appendChild(legendDiv)

// Append the legend div to the document body or any other container
var i=0;
style_list.forEach(function (s){

    
    var color=s.getImage().getFill().getColor()

   // console.log(s.getImage().getFill().getColor())
    var item = document.createElement('div');
    item.style.backgroundColor = color;
    item.textContent = i; // You can customize the text based on your requirements
    legendDiv.appendChild(item);
    i++
})
//var style_p=new Style({image:new CircleStyle({radius:2, fill: new Fill({color: 'red'}),})})
function retrieve_appropriate_pri_data(f_name='data/autopurifikacija/Cestice_001.txt'){

 fetch(f_name)
  .then(function (response) {
    return response.text();
  })
  .then(function (tdata) {
    source_arr.clear()
    let features = [];
    let jdata = tdata.split('\n\r')

    jdata.forEach(function (pp) {
       // console.log (pp)
        let data_p=pp.replace(/[\r\n]/gm, '').split(';')
        if (data_p.length>6){
       
        let feature = new Feature(
           new Point(fromLonLat([ data_p[0],data_p[1] ]))
      );
 

      feature.setStyle(style_list[Math.round(data_p[3])])

       features.push(feature);
    }
    });
    source_arr.addFeatures(features);
    //console.log('loaded')
   // console.log(style_list)

  });

}

function lpad(value, padding) {
    var zeroes = new Array(padding+1).join("0");
    return (zeroes + value).slice(-padding);
}


datum_slider_radar.onchange=function() {

  var radar_index=lpad(datum_slider_radar.value,3)//zeroFilled = ('000' + datum_slider_radar.value).substr(-3) 
 // console.log(radar_index)
  var f= 'Cestice_'+radar_index+'.txt'
  //console.log('data/radar_video/'+f)

  //document.getElementById('radar_datum_value').innerHTML=f.substring(5,20)
  retrieve_appropriate_pri_data('data/autopurifikacija/'+f)

}

retrieve_appropriate_pri_data()

var i=0
var ply_radar=false
const playBtn=document.getElementById('play_autopuri')
playBtn.innerHTML='<img class="but_video" src="image/play.png" >'

function playFn(){
 
if (datum_slider_radar.value<703){
  datum_slider_radar.value++
 
  var event = new Event('change');
// Dispatch it.
datum_slider_radar.dispatchEvent(event);
}
}
var int_id=0
playBtn.onclick= function (properties) {
  
 if (!ply_radar){
  ply_radar=true
  int_id=setInterval(playFn,500)
  playBtn.innerHTML='<img class="but_video" src="image/pause.png" >'

 }
 else{
  ply_radar=false
  clearInterval(int_id)
  playBtn.innerHTML='<img class="but_video" src="image/play.png" >'

 }

}


/******** */

window.autopuri_layer=new TileLayer(
    //https://image.discomap.eea.europa.eu/arcgis/rest/services/EUHydro/EUHydro_Coastline/MapServer/export?bbox=1736814.5569279396%2C5302504.860276667%2C2038769.0603569464%2C5492589.2494054455&bboxSR=102100&imageSR=102100&size=1401%2C882&dpi=105.60000228881836&format=png32&transparent=true&layers=show%3A0&f=image
    {
      title: 'Autopurifikacija',
     source: new TileWMS({
      url: 'http://caat.fesb.hr:8080/geoserver/sentinel_time/wms',
      params: {'LAYERS': 'sentinel_time:Data_q200','TIME':'200'},
    }
    )  ,
    visible:false,
    })


    
  /*  function lpad(value, padding) {
      var zeroes = new Array(padding+1).join("0");
      return (zeroes + value).slice(-padding);
  }*/


const autopuri_range=document.getElementById('autopuri_tiff_slider')

autopuri_range.onchange=function() {

  let timeval=lpad(autopuri_range.value,4)
  //console.log(timeval)
autopuri_layer.getSource().updateParams({'TIME':timeval} );
}




var ply_radarTff=false
const playBtnTiff=document.getElementById('play_autopuri_tiff')
playBtnTiff.innerHTML='<img class="but_video" src="image/play.png" >'

function playFnTiff(){
 
if (autopuri_range.value<703){
    autopuri_range.value++
 
  var event = new Event('change');
// Dispatch it.
autopuri_range.dispatchEvent(event);
}
}
var int_id_tf=0
playBtnTiff.onclick= function (properties) {
  
 if (!ply_radarTff){
    ply_radarTff=true
    int_id_tf=setInterval(playFnTiff,500)
  playBtnTiff.innerHTML='<img class="but_video" src="image/pause.png" >'

 }
 else{
    ply_radarTff=false
  clearInterval(int_id_tf)
  playBtnTiff.innerHTML='<img class="but_video" src="image/play.png" >'

 }

}
 


//console.log('autopuri gotov')